import { Icon } from '@abb/common-ux';
import * as React from 'react';

interface IDefaultTextState {
  displayAboutText: boolean;
  displayGetStartedText: boolean;
  displayRequestLogText: boolean;
}

export class DefaultText extends React.Component<any, IDefaultTextState> {
  constructor(props: any) {
    super(props);

    this.state = {
      displayAboutText: false,
      displayGetStartedText: false,
      displayRequestLogText: false,
    };
  }

  render() {

    let aboutScreenText;
    if (this.state.displayAboutText) {
      aboutScreenText = (
        <React.Fragment>
          <h2>About</h2>
          <p>The mySpareParts Analyzer is a tool used to analyze current parts inventories for customer sites. </p>
          <div className='row' style={{ marginRight: '15px', marginLeft: '5px', marginBottom: '8.5px' }}>
            <div className='col-lg-1' style={{ paddingTop: '10px' }}>
              <Icon icon='information_circle1' />
            </div>
            <div className='col-lg-11' style={{ borderTop: '1px solid black', borderBottom: '1px solid black' }}>
              Contact <a style={{ color: 'red' }} href={`mailto:us-iasvsupport@abb.com?Subject=Parts%20Manager%20Questions`} target='_top'>us-iasvsupport@abb.com</a> if for any technical issues using this tool.
            </div>
          </div>
          <a style={{ cursor: 'pointer' }} onClick={this.toggleAboutText} >Close</a>
          <p />
        </React.Fragment>
      );
    }

    let getStartedText;
    if (this.state.displayGetStartedText) {
      getStartedText = (
        <React.Fragment>
          <h2>Get Started</h2>
          <p>
            The Get Started tab is where customers download the parts template, add spare parts information regarding a particular site, and upload the template for analysis by ABB parts specialists.
          </p>
          <p>1.	Click the <b>Download</b> button to download the template.  If the template was previously downloaded, skip this step and proceed to Step 2.</p>
          <p>2. Add spare parts information following instruction and format specified in the template.</p>
          <p>3. Click <b>Upload File</b> button select and upload the completed template.</p>
          <p>4. If an error occurs during file upload, correct the issue.  Reupload file.</p>
          <p>5. A successful upload is indicated in green along with a date/time stamp.</p>
          <p>6. Click <b>Get the Full Report</b> button.</p>
          <p>7. Complete contact information and answer survey questions. Click <b>Submit.</b></p>
          <a style={{ cursor: 'pointer' }} onClick={this.toggleDownloadButtonText} >Close</a>
          <p />
        </React.Fragment>
      );
    }

    let requestLogText;
    if (this.state.displayRequestLogText) {
      requestLogText = (
        <React.Fragment>
          <h2>Request Log</h2>
          <h3>About</h3>
          <p>
            The Request Log is a list of parts analysis requests submitted by customers.  This view is only accessible by ABB Parts Specialists.  Select the <b>Requests</b> tab.
          </p>
          <p>
            Items in this list can be sorted by selecting column titles or specifically filtered using the filter function button ({<Icon icon='filter' color='black' size='small' />}) and completing the dialogue form.
          </p>
          <p>
            To view a request, select a row.  The status of the request appears in the upper right.  Status conditions are:
          </p>
          <ul>
            <li>Rejected indicates the request has been reviewed and will not be processed any further.  No further action is possible.</li>
            <li>Approved indicates the request has been reviewed and a customer version of the Request Summary has been emailed.</li>
            <li>Pending indicates that the request is available for a review.</li>
          </ul>
          <h3>Matched and Unmatched Parts</h3> 
          <p>
            Matched parts have been identified as ABB part numbers (exact matches only).
          </p> 
          <p> 
            Unmatched parts could not be identified as ABB part numbers. In some instances, part numbers may become embedded in descriptions, get inadvertently shortened, or have some other error. Similarly, the absence of data does not mean a negative, it could just be a case of missing data. If you feel this is not an accurate representation of your non-ABB parts inventory, please revisit your upload.
          </p>
          <h3>Process Request</h3>  
          <p>
            Requests are initially assigned to a Parts Specialist based on the country of the contact submitting the request.  For countries without Parts Specialists, a request will remain unassigned until ownership is taken.  If needed, any request can be reassigned to another Parts Specialist by using Take Ownership process. 
          </p>
          <p>
            Select a pending request.  If a request is assigned to your name, proceed with the review to reject or approve the request. If a request is assigned to another name or there is no assignment at this time, the <b>Take Ownership</b> button appears on the Request Summary.  Select <b>Take Ownership</b> button to assign yourself as the ABB Parts Specialist.  Once assigned, click the corresponding button to reject or approve the request.
          </p>
          <p>
            To reject a request, select <b>Reject</b> button to complete the dialogue form and no email will be sent to the customer.   Entered lead generated status and comments will be saved as part of the request on the Request Log.
          </p>
          <p>
            To approve the request, select the <b>Approve</b> button to complete the dialogue form and an email will be sent to the customer along with your name, email address and the Customer version of Request Summary.  Entered comments will be saved as part of the request on the Request Log.
          </p>
          <p>
            Assign a site (if not already assigned) by selecting <Icon color='#0c74da' icon='plus_in_circle' /> <span style={{color: '#0c74da'}}>Assign a site</span> in the Site Details pane. Site details can be edited or deleted by selecting <Icon color='#0c74da' icon='edit'/><Icon color='#0c74da' icon='trash'/> icons. 
          </p>
          <p>
            Once a site is assigned and approved, the <b>Upload to mySpareParts Manager</b> button appears in the upper right. This button allows a user to submit a list of parts to the mySpareParts Manager. Note, if there are unmatched parts, there will be no transfer of information. If there is existing part inventory, there will be no transfer of information for those specific parts. Additionally, <span onClick={this.navigateToLink('https://industrial-automation-service.abb.com/parts/')}><a>parts can be added to inventory by following the manual process implemented in mySpareParts Manager.</a></span> 
          </p> 
          <p>
            After uploading to the mySpareParts Manager, <b>View Sites in mySpareParts Manager</b> hyperlink appears and the Upload to mySpareParts Manager button is no longer present. Use this button to open the current site in the mySpareParts Manager.
          </p> 
          <p> 
            Once parts have been submitted to the mySpareParts Manager, a request can no longer be changed or removed.  
          </p>
          <a style={{ cursor: 'pointer' }} onClick={this.toggleRequestLogText} >Close</a>
          <p />
        </React.Fragment>
      );
    }

    return (
      <div style={{ fontWeight: 'normal' }}>
        <h2>mySpareParts Analyzer</h2>
        <hr className='helpMenuStyle' />
        <p>
          <a style={{ cursor: 'pointer' }} onClick={this.toggleAboutText} >About</a>
        </p>
        {aboutScreenText}
        <p>
          <a style={{ cursor: 'pointer' }} onClick={this.toggleDownloadButtonText} >Get Started</a>
        </p>
        {getStartedText}
        <p>
          <a style={{ cursor: 'pointer' }} onClick={this.toggleRequestLogText} >Request Log</a>
        </p>
        {requestLogText}
      </div>
    );
  }

  toggleAboutText = () => {
    this.setState({ displayAboutText: !this.state.displayAboutText });
  }
  
  navigateToLink = (pathName: string) => (e: React.MouseEvent<HTMLDivElement>) => {
    window.location.href = pathName; 
  }

  toggleDownloadButtonText = () => {
    this.setState({ displayGetStartedText: !this.state.displayGetStartedText });
  }
  toggleRequestLogText = () => {
    this.setState({ displayRequestLogText: !this.state.displayRequestLogText });
  }

}
